<template>
  <div class="order-submission">
    <!-- <div class="iconfont icon-unionpay"></div> -->
    <div
      class="allAddress"
      :style="store_self_mention ? '' : 'padding-top: 0.2rem'"
    >
      <div class="nav acea-row">
        <div
          class="item font-color-red"
          :class="shipping_type === 0 ? 'on' : 'on2'"
          @click="addressType(0)"
          v-if="store_self_mention"
        ></div>
        <div
          class="item font-color-red"
          :class="shipping_type === 1 ? 'on' : 'on2'"
          @click="addressType(1)"
          v-if="store_self_mention"
        ></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-if="shipping_type === 0"
        @click="addressTap"
      >
        <div class="addressCon" v-if="addressInfo.real_name">
          <div class="name">
            {{ addressInfo.real_name }}
            <span class="phone">{{ addressInfo.phone }}</span>
          </div>
          <div>
            <span class="default font-color-red" v-if="addressInfo.is_default"
              >[默認]</span
            >
            {{ addressInfo.province }}{{ addressInfo.city
            }}{{ addressInfo.district }}{{ addressInfo.detail }}
          </div>
        </div>
        <div class="addressCon" v-else>
          <div class="setaddress">設置收貨地址</div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div
        class="address acea-row row-between-wrapper"
        v-else
        @click="showStoreList"
      >
        <div class="addressCon">
          <div class="name" v-if="storeItem">
            {{ storeItem.name }}
            <span class="phone" v-text="storeItem.phone"></span>
          </div>
          <div
            v-text="storeItem.address + ',' + storeItem.detailed_address"
            v-if="storeItem && storeItem.address && storeItem.detailed_address"
          ></div>
        </div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="line">
        <img src="@assets/moblie/images/line.jpg" />
      </div>
      <div class="warm-tip">
        <div>
          <div class="title">溫馨提示</div>
          <div class="content">
            <p v-if="userInfo.delivery_type=='邮政EMS'">1.收货地址请填写详细(小区精确到几栋几零几,乡镇地址精确到门牌号),否则会被海关系统自动筛查判定为地址不详,导致申报失败!!!(07576663710为海关核验电话,若接到该电话,麻烦配合海关核验信息)</p>
            <p v-if="userInfo.delivery_type=='邮政EMS'">2.因订单备注无法体现在面单中,若有特殊备注需要让快递小哥看到,请在地址末尾()备注！</p>
            <p v-else>1.因订单备注无法体现在面单中,若有特殊备注需要让快递小哥看到,请在地址末尾()备注！</p>
            <p v-if="userInfo.delivery_type=='邮政EMS'">3.常温运输(跨境无法做到温控),已咨询厂家可常温运输,收货请放置阴凉处存储或放入冰箱保鲜层(使用前请提前取出恢复常温)！</p>
            <p v-if="userInfo.delivery_type=='邮政EMS'">4.若遇海关随机抽查核验包裹时，请按照海关的核验短信提醒在5个自然日之内进行包裹身份信息核验，有且仅有一次核验机会，超时将影响包裹清关。</p>
            <p v-if="userInfo.delivery_type=='邮政EMS'" style="font-weight=600">注：填写核验信息时，请务必确认填写的信息与订单信息一致(收件人,证件,订单总金额[实际支付金额]),否则将导致核验失败(核验失败需要收取二次发货运费(39),介意者请选择韵达)。非常重要！！！</p>
          </div>
        </div>
      </div>
    </div>
    <OrderGoods :evaluate="0" :cartInfo="orderGroupInfo.cartInfo"></OrderGoods>
    <div class="wrapper">
      <div
        class="item acea-row row-between-wrapper"
        @click="couponTap"
        v-if="deduction === false"
      >
        <div>優惠券</div>
        <div class="discount">
          {{ usableCoupon.coupon_title || "請選擇" }}
          <span class="iconfont icon-jiantou"></span>
        </div>
      </div>
      <!--
      <div class="item acea-row row-between-wrapper" v-if="deduction === false">
        <div>積分抵扣</div>
        <div class="discount">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="useIntegral" />
                <i class="icon"></i>
                <span class="integral">
                  當前積分
                  <span class="num font-color-red">
                    {{ userInfo.integral || 0 }}
                  </span>
                </span>
              </label>
            </div>
          </div>
        </div>
      </div>
      -->
      <div class="item acea-row row-between-wrapper">
        <div>收件手机号是否为微信绑定手机号码</div>
        <div class="discount" style="width: auto">
          <div class="select-btn">
            <div class="checkbox-wrapper">
              <label class="well-check">
                <input type="checkbox" v-model="isWxPhone" />
                <i class="icon"></i>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="!isWxPhone">
        <div>微信手机</div>
        <div class="wx-phone">
          <input v-model="userInfo.wx_phone" />
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="!isWxPhone">
        <div class="verify-title">验证码</div>
        <div class="verify">
          <input v-model="userInfo.verify_code" />
        </div>
        <button class="verify-btn" @click="sendVerify" :disabled="disabled">
          {{ text }}
        </button>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>快遞選擇</div>
        <div class="delivery-type">
          <el-select
            v-model="userInfo.delivery_type"
            placeholder="請選擇"
            @change="changeDelivery"
          >
            <el-option v-for="delivery in delivery_sel" :label="delivery" :value="delivery"></el-option>
          </el-select>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper">
        <div>清關口岸</div>
        <div class="delivery-type">
          {{userInfo.delivery_type=='邮政EMS'?"佛山口岸":(userInfo.delivery_type=='韵达快递'?"长沙口岸":"深圳口岸")}}
        </div>
      </div>
      <div class="item acea-row" style="color: red" v-if="cartInfo[0].productInfo.is_prescription">
        默认物流为{{userInfo.delivery_type}},全额運費39{{
            orderPrice.pay_postage <39
              ? ",免基础運費"
              : ""
          }},{{userInfo.delivery_type=='邮政EMS'?"核验失败需要收取包裹二次发货运费(39),介意者请选择韵达,(预计7-15个工作日送达,请知晓！)":"可自主选择邮政,当韵达无法送达时,将默认发邮政,(预计9-15个工作日送达,请知晓)"}}
      </div>
      <div class="item acea-row" style="color: red" v-if="userInfo.delivery_type=='中通国际'">
        默认物流为中通国际,全额运费27,当中通无法送达时,系统将自动选择其他可支持的物流,（预计7-15个工作日送达，请知晓！）
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="
          orderGroupInfo.priceGroup.vipPrice > 0 &&
            userInfo.vip &&
            pinkId == 0 &&
            orderGroupInfo.bargain_id == 0 &&
            orderGroupInfo.combination_id == 0 &&
            orderGroupInfo.seckill_id == 0
        "
      >
        會員優惠
        <div class="discount">-￥{{ orderGroupInfo.priceGroup.vipPrice }}</div>
      </div>
      <!--
      <div class="item acea-row row-between-wrapper" v-if="shipping_type === 0">
        <div>快遞費用</div>
        <div class="discount">
          {{
            orderPrice.pay_postage > 0
              ? "￥" + orderPrice.pay_postage
              : "免運費"
          }}
        </div>
      </div>
      <div v-else>
        <div class="item acea-row row-between-wrapper">
          <div>聯繫人</div>
          <div class="discount">
            <input
              type="text"
              placeholder="請填寫您的聯繫姓名"
              v-model="contacts"
            />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div>聯繫電話</div>
          <div class="discount">
            <input
              type="text"
              placeholder="請填寫您的聯繫電話"
              v-model="contactsTel"
            />
          </div>
        </div>
      </div>-->
      <div class="item acea-row row-between-wrapper" v-if="orderGroupInfo.priceGroup.taxesPrice>0">
        <div>稅費</div>
        <div class="discount">￥{{ orderGroupInfo.priceGroup.taxesPrice }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderGroupInfo.priceGroup.extraPrice>0">
        <div>操作手续费</div>
        <div class="discount">￥{{ orderGroupInfo.priceGroup.extraPrice }}</div>
      </div>
      <div class="item">
        <div>備註信息</div>
        <textarea
          placeholder="請添加備註（150字以內）"
          v-model="mark"
        ></textarea>
      </div>
    </div>
    <div class="wrapper">
      <!-- <div class="promise" v-if="userInfo.certification_type != 2">
        <div>
          为了保障购药者的权益，请购药者打印以下协议进行签名和盖手印（也可手抄本协议）
        </div>
        <div class="demo-image__preview image-box">
          <el-image
            style="width: 100px; height: 100px"
            :src="promiseUrl"
            :preview-src-list="srcList"
          >
          </el-image>
          <div class="big-view">（点击放大）</div>
        </div>
      </div> -->
      <div class="item">
        <div class="prove">
          上傳1張相關證明
          <p>1. 患者身份證<span class="font-color-red">正反面</span>或戶口簿圖片</p>
          <p class="font-color-red">2. 收件人與身份證件需一致（海關要求）</p>
          <p>3. 若低於<span class="font-color-red">6周歲</span>，建議提供監護人身份證件</p>
        </div>
        <el-upload
          class="upload-demo"
          :multiple="true"
          :action="url"
          :headers="headers"
          :on-remove="handleRemove"
          :file-list="fileList"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
          list-type="picture"
          accept="image/*"
        >
          <el-button size="small" type="primary">點擊上傳</el-button>
          <div slot="tip" class="el-upload__tip">
            請上傳身份證<span class="font-color-red">正反面</span>/戶口本照片
          </div>
        </el-upload>
        <div class="prove font-color-red" v-if="cartInfo[0].productInfo.is_prescription">
          3.相關處方/病歷
          <div>①就診人信息(病历本需提供病历封面)</div>
          <div v-if="!isTyrvaya">
            ②帶“建議使用0.01%阿托品滴眼液”/“阿托品滴眼液”字樣，<span
              class="show-example"
              @click="showExample"
              >示例</span
            >
          </div>
          <div v-else>
            ②帶“建議伐尼克兰鼻喷剂”/“伐尼克兰”字樣，<span
              class="show-example"
              @click="showExample2"
              >示例</span
            >
          </div>
        </div>
        <el-image
          src="https://www.atropin.cn/uploads/attach/2021/12/20211210/685996edd3b68d8cf85d2ca57acc3525.png"
          :preview-src-list="srcList"
          v-if="isShowExample"
        ></el-image>
        <el-image
          src="https://www.atropin.cn/uploads/attach/2023/03/20230307/ad90ed9cc98e9d03484b24cd0a53e6bc.jpg"
          :preview-src-list="srcList"
          v-if="isShowExample"
        ></el-image>
        <el-image
          src="https://www.atropin.cn/uploads/attach/2023/07/20230726/433314a3ff7ea4f323556d94410e3d28.png"
          :preview-src-list="srcList2"
          v-if="isShowExample2"
        ></el-image>
        <el-image
          src="https://www.atropin.cn/uploads/attach/2023/07/20230726/d6d90014fbd7d7a87371c6b45ed41b77.png"
          :preview-src-list="srcList2"
          v-if="isShowExample2"
        ></el-image>
        <el-upload
          class="upload-demo"
          :multiple="true"
          :action="url"
          :headers="headers"
          :on-remove="handleRemoveCert"
          :file-list="fileListCert"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccessCert"
          list-type="picture"
          accept="image/*"
          v-if="cartInfo[0].productInfo.is_prescription"
        >
          <el-button size="small" type="primary">點擊上傳</el-button>
          <div slot="tip" class="el-upload__tip">請上傳处方</div>
        </el-upload>
      </div>
      <div>4.以上提供的信息僅限清關使用,平台将保护您的个人信息,不会泄露您的个人信息！</div>
      <!-- 研发机构 -->
      <!-- <div class="item" v-else>
        <QuotedPrice
          :productPriceList="productPriceList"
          :cartInfo="cartInfo"
          @changePrice="changePrice"
        >
        </QuotedPrice>
      </div> -->
    </div>

    <div class="wrapper">
      <div class="item">
        <div>支付方式</div>
        <div class="list">
          <div
            class="payItem acea-row row-middle"
            :class="active === 'weixin' ? 'on' : ''"
            @click="payItem('weixin')"
            v-show="isWeixin"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-weixin2"
                :class="active === 'weixin' ? 'bounceIn' : ''"
              ></div>
              微信支付
            </div>
            <div class="tip">微信快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'alipay' ? 'on' : ''"
            @click="payItem('alipay')"
            v-show="true"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-zhifubao"
                :class="active === 'alipay' ? 'bounceIn' : ''"
              ></div>
              支付寶支付
            </div>
            <div class="tip">支付寶快捷支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'unionpay' ? 'on' : ''"
            @click="payItem('unionpay')"
            v-show="true"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="unionpay-logo"
                :class="active === 'unionpay' ? 'bounceIn' : ''"
              >
                <img src="@/assets/moblie/images/unionpay-logo.png" />
              </div>
              银联支付
            </div>
            <div class="tip">银联支付</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'yue' ? 'on' : ''"
            @click="payItem('yue')"
            v-show="false"
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-icon-test"
                :class="active === 'yue' ? 'bounceIn' : ''"
              ></div>
              餘額支付
            </div>
            <div class="tip">可用餘額：{{ userInfo.now_money || 0 }}</div>
          </div>
          <div
            class="payItem acea-row row-middle"
            :class="active === 'offline' ? 'on' : ''"
            @click="payItem('offline')"
            v-if="
              offlinePayStatus === 1 &&
                deduction === false &&
                shipping_type === 0
            "
          >
            <div class="name acea-row row-center-wrapper">
              <div
                class="iconfont icon-yinhangqia"
                :class="active === 'offline' ? 'bounceIn' : ''"
              ></div>
              線下支付
            </div>
            <div class="tip">線下方便支付</div>
          </div>
        </div>
      </div>
    </div>

    <div class="moneyList">
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.total_price !== undefined"
      >
        <div>商品總價：</div>
        <div class="money">￥{{ orderPrice.total_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.pay_postage > 0"
      >
        <div>運費{{ orderPrice.pay_postage <39?"(附加)":"" }}：</div>
        <div class="money">+￥{{ orderPrice.pay_postage }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderGroupInfo.priceGroup.taxesPrice > 0"
      >
        <div>稅費：</div>
        <div class="money">+￥{{ orderGroupInfo.priceGroup.taxesPrice }}</div>
      </div>
      <div class="item acea-row row-between-wrapper" v-if="orderGroupInfo.priceGroup.extraPrice>0">
        <div>操作手续费：</div>
        <div class="money">+￥{{ orderGroupInfo.priceGroup.extraPrice }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.coupon_price > 0"
      >
        <div>優惠券抵扣：</div>
        <div class="money">-￥{{ orderPrice.coupon_price }}</div>
      </div>
      <div
        class="item acea-row row-between-wrapper"
        v-if="orderPrice.deduction_price > 0"
      >
        <div>積分抵扣：</div>
        <div class="money">-￥{{ orderPrice.deduction_price }}</div>
      </div>
    </div>
    <div class="risk-warning" v-if="isShowWarning">
      <div class="risk-mask" @click="cancelSubmit"></div>
      <div class="risk-body">
        <div class="risk-title">温馨提示</div>
        <div class="risk-content">
          同一天不能连续下单，会增加海关查验的概率，从而导致清关时效延长，故请间隔4-5天后再下单
        </div>
        <div class="risk-footer">
          <div class="risk-cancel" @click="cancelSubmit">取消</div>
          <div class="risk-continue" @click="createOrder">继续下单</div>
        </div>
      </div>
    </div>
    <div class="risk-warning" v-if="isShowHint">
      <div class="risk-mask" @click="cancelSubmit"></div>
      <div class="risk-body">
        <div class="risk-title">支付须知</div>
        <div class="risk-content">
          受疫情影响清关时效将至少延迟7个工作日，因此整体物流时效将至少延迟15个工作日
          ，下单默认知晓物流情况！
        </div>
        <div class="risk-content">
          受当地防疫政策影响以下地区不接收国际件，因此暂停发货：全境（新疆、内蒙、河北、
          甘肃、黑龙江,、浙江、山东、上海），河南（郑州、洛阳），湖北襄阳，广东（深圳、
          肇庆），安徽（黄山，宣城），福建(宁德，泉州)
        </div>
        <div class="risk-content">
          海外货物一经发货将申报海关，非质量问题不支持退换，发货后退款将扣除相应产生的运费、拦截费及关税（实付款的13%）
        </div>
        <div class="risk-footer">
          <div class="risk-cancel" @click="checkMore">查看更多</div>
          <div class="risk-continue" @click="beforeBuy">已知晓</div>
        </div>
      </div>
    </div>
    <div class="risk-warning" v-if="isShowHint2">
      <div class="risk-mask" @click="cancelSubmit"></div>
      <div class="risk-body">
        <div class="risk-title"></div>
        <div class="risk-content">
          由于香港疫情，仓库暂停发货，恢复将会按顺序发货，下单默认知晓该物流情况！
        </div>
        <div class="risk-footer">
          <div class="risk-cancel" @click="cancelSubmit">取消</div>
          <div class="risk-continue" @click="beforeBuy">已知晓</div>
        </div>
      </div>
    </div>
    <div style="height: 1.2rem"></div>
    <div class="footer acea-row row-between-wrapper">
      <div>
        合計:
        <span class="font-color-red">￥{{ orderPrice.pay_price }}</span>
      </div>

      <div class="settlement" @click="beforeBuy">立即結算</div>
      <!--
      <div class="settlement" @click="createOrder">
        提交审核
      </div>
      -->
    </div>

    <CouponListWindow
      v-on:couponchange="changecoupon($event)"
      v-model="showCoupon"
      :price="orderPrice.total_price"
      :checked="usableCoupon.id"
      :cartid="cartid"
      @checked="changeCoupon"
    ></CouponListWindow>
    <AddressWindow
      @checked="changeAddress"
      @redirect="addressRedirect"
      v-model="showAddress"
      :checked="addressInfo.id"
      ref="mychild"
    ></AddressWindow>
  </div>
</template>

<script>
import OrderGoods from "@components/moblie/OrderGoods";
import CouponListWindow from "@components/moblie/CouponListWindow";
import AddressWindow from "@components/moblie/AddressWindow";
// import QuotedPrice from "@components/moblie/QuotedPrice";
import {
  postOrderConfirm,
  postOrderComputed,
  createOrder,
  orderDetail,
  checkRepurchase
} from "@api/order";
import { storeListApi } from "@api/store";
import { getUser, registerVerify, doVerifyCode } from "@api/user";
// import { pay } from "@libs/wechat";
import { isWeixin, VUE_APP_API_URL } from "@utils";
import { mapGetters } from "vuex";
import cookie from "@utils/store/cookie";
import * as imageConversion from "image-conversion";
import SendVerifyCode from "@/mixins/SendVerifyCode";
// import lrz from "lrz";
// import ClipboardJS from "clipboard";
const NAME = "OrderSubmission",
  _isWeixin = isWeixin();
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
export default {
  name: NAME,
  components: {
    OrderGoods,
    CouponListWindow,
    AddressWindow
    // QuotedPrice
  },
  props: {},
  mixins: [SendVerifyCode],
  computed: {
    ...mapGetters(["storeItems"]),
    storeItem: function() {
      if (JSON.stringify(this.storeItems) == "{}") {
        return this.storeList;
      } else {
        return this.storeItems;
      }
    }
  },
  data: function() {
    return {
      orderInfo: {}, //订单详情
      Afterpurchase: {}, //查询复购返回的信息
      cartid: "",
      offlinePayStatus: 2,
      from: _isWeixin ? "weixin" : "weixinh5",
      deduction: true,
      isWeixin: _isWeixin,
      pinkId: 0,
      active: _isWeixin ? "weixin" : "alipay",
      showCoupon: false,
      showAddress: false,
      addressInfo: {},
      couponId: 0,
      orderGroupInfo: {
        priceGroup: {}
      },
      usableCoupon: {},
      addressLoaded: false,
      useIntegral: false,
      isWxPhone: true,
      orderPrice: {
        pay_price: "計算中",
        coupon_price: 0
      },
      mark: "",
      system_store: {},
      shipping_type: 0,
      contacts: "",
      contactsTel: "",
      store_self_mention: 0,
      userInfo: {},
      storeList: {},
      delivery_sel:["邮政EMS","韵达快递"],
      delivery_type: "邮政EMS",
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      url: `${VUE_APP_API_URL}/upload/idcard`,
      fileList: [],
      fileListCert: [],
      cartInfo: [], //购物车详情
      productPriceList: [],
      storePostage: 0, // 运费
      promiseUrl:
        "https://www.atropin.cn/uploads/attach/2021/12/20211210/685996edd3b68d8cf85d2ca57acc3525.png",
      srcList: [
        "https://www.atropin.cn/uploads/attach/2021/12/20211210/685996edd3b68d8cf85d2ca57acc3525.png",
        "https://www.atropin.cn/uploads/attach/2023/03/20230307/ad90ed9cc98e9d03484b24cd0a53e6bc.jpg"
      ],
      srcList2: [
        'https://www.atropin.cn/uploads/attach/2023/07/20230726/433314a3ff7ea4f323556d94410e3d28.png',
        'https://www.atropin.cn/uploads/attach/2023/07/20230726/d6d90014fbd7d7a87371c6b45ed41b77.png'
      ],
      userIdentity: {},
      isShowWarning: false,
      isShowExample: false,
      isShowExample2: false,
      isShowHint: false,
      isHinted: false,
      isShowHint2: false,
      isHinted2: false,
      repurchaseIdcards: [],
      repurchaseCerts: [],
      isTyrvaya: false
    };
  },
  watch: {
    useIntegral() {
      let that = this;
      setTimeout(() => {
        that.computedPrice();
      }, 200);
    },
    $route(n) {
      if (n.name === NAME) {
        this.getCartInfo();
        this.fileList = [];
        this.fileListCert = [];
        this.cartInfo = [];
        this.checkRepurchase();
      }
    },
    shipping_type() {
      let that = this;
      setTimeout(() => {
        that.computedPrice();
      }, 200);
    },
    productPriceList() {
      let that = this;
      setTimeout(() => {
        that.computedPrice();
      }, 200);
    }
  },
  mounted: function() {
    console.log("详情页面》》》》》》》");
    let that = this;
    console.log("isWeixin");
    console.log(this.isWeixin);
    console.log(_isWeixin);
    that.getCartInfo();
    that.getList();
    this.checkRepurchase();
    if (that.$route.query.pinkid !== undefined)
      that.pinkId = that.$route.query.pinkid;
    if (that.$route.params.id !== undefined)
      that.cartid = that.$route.params.id;
  },
  methods: {
    //查询复购
    checkRepurchase() {
      let that = this;
      checkRepurchase().then(res => {
        this.Afterpurchase = res;
        console.log(res, this.Afterpurchase, "查询》》》》》");

        let {
          idcard_images,
          prescription_images,
          real_name,
          id_card,
          id_card_type,
          id_card_start_date,
          id_card_end_date
        } = res.data.result;
        if (!idcard_images) {
          idcard_images = [];
        }
        if (idcard_images.constructor != Array) {
          idcard_images = [{ name: idcard_images, url: idcard_images }];
        }
        that.fileList = idcard_images.map((item, index) => {
          console.log(item, index);
          return {
            name: item,
            url: item
          };
        });
        if (!prescription_images) {
          prescription_images = [];
        }
        if (prescription_images.constructor != Array) {
          prescription_images = [
            { name: prescription_images, url: prescription_images }
          ];
        }
        that.fileListCert = prescription_images.map((item, index) => {
          console.log(item, index);
          return {
            name: item,
            url: item
          };
        });
        that.repurchaseIdcards = idcard_images;
        that.repurchaseCerts = prescription_images;
        that.userIdentity.name = real_name;
        that.contacts = real_name;
        that.userIdentity.idcard = id_card;
        that.userIdentity.idcard_type = id_card_type;
        that.userIdentity.idcard_start_date = id_card_start_date;
        that.userIdentity.idcard_end_date = id_card_end_date;
      });
    },
    //购买提示
    beforeBuy() {
      console.log("tishi");
      /*
      console.log(this.isHinted)
      if (!this.isHinted) {
        // (this.isShowHint = true)
        return (this.isHinted = true);
      }*/
      this.createOrder();
    },
    afterHint() {
      console.log("tishi");
      console.log(this.isHinted2)
      if (!this.isHinted2) {
        this.isHinted2 = true;
        return (this.isShowHint2 = true);
      }
      this.createOrder();
    },
    sendVerify() {
      let data = {
        phone: this.userInfo.wx_phone,
        type: "verify",
        key: "",
        code: ""
      };
      registerVerify(data)
        .then(res => {
          console.log(res);
          this.$dialog.toast({
            mes: res.msg
          });
          this.sendCode();
        })
        .catch(err => {
          this.$dialog.toast({
            mes: err.msg
          });
        });
    },
    showExample() {
      this.isShowExample = !this.isShowExample;
    },
    showExample2(){
      this.isShowExample2 = !this.isShowExample2;
    },
    //改变快递
    changeDelivery(e) {
      console.log("change");
      console.log(e);
      console.log(this.cartInfo);
      // if (this.cartInfo && this.cartInfo[0].productInfo.id !== 4985) {
      //   this.userInfo.delivery_type = "韵达快递";
      //   this.computedPrice();
      //   if (e == "顺丰速递") {
      //     this.$dialog.toast({ mes: "请联系客服" });
      //   }
      // } else {
      //   this.userInfo.delivery_type = e;
      // }
      this.userInfo.delivery_type = e;
      this.computedPrice();
    },
    // 获取门店列表数据
    getList: function() {
      let data = {
        latitude: cookie.get(LATITUDE) || "", //纬度
        longitude: cookie.get(LONGITUDE) || "", //经度
        page: 1,
        limit: 10
      };
      storeListApi(data)
        .then(res => {
          this.storeList = res.data.list[0];
        })
        .catch(err => {
          this.$dialog.error(err.msg);
        });
    },
    // 跳转到门店列表
    showStoreList() {
      this.$store.commit("GET_TO", "orders");
      this.$router.push("/shop/storeList/orders");
    },
    cancelSubmit() {
      this.isShowWarning = false;
      this.isShowHint = false;
      this.isShowHint2 = false;
    },
    checkMore() {
      this.isShowHint = false;
      this.$router.push(`/district-area?id=${this.$route.params.id}`);
    },
    getUserInfo() {
      getUser()
        .then(res => {
          this.userInfo = res.data;
          this.userInfo["delivery_type"] = "邮政EMS";
          console.log("userInfo");
          console.log(this.cartInfo);
          if (!this.cartInfo[0].productInfo.is_prescription) {
             this.userInfo["delivery_type"] = "中通国际";
             this.delivery_sel = ["中通国际"];
          }
          console.log(this.userInfo);
        })
        .catch(() => {});
    },
    addressType: function(index) {
      if (index && !this.system_store.id)
        return this.$dialog.error("暫無門店信息，您無法選擇到店自提！");
      this.shipping_type = index;
    },
    computedPrice() {
      // 公司报价单实时更新总价
      this.realTimePrice = 0;
      this.productPriceList.forEach(item => {
        this.realTimePrice += item.moneySum - item.sumPrice;
      });
      this.realTimePrice = this.realTimePrice - parseFloat(this.storePostage);

      // 患者时需重置
      if (this.userInfo.certification_type != 2) {
        this.realTimePrice = 0;
      }

      // 如果this.realTimePrice 小于 0 直接返回, 要不然会报错，虽然不影响
      if (this.realTimePrice < 0) return;

      let shipping_type = this.shipping_type;
      postOrderComputed(this.orderGroupInfo.orderKey, {
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        shipping_type: parseInt(shipping_type) + 1,
        payType: this.active,
        realTimePrice: this.realTimePrice,
        delivery_type: this.userInfo.delivery_type
        //delivery_type: "邮政EMS"
      })
        .then(res => {
          const data = res.data;
          if (data.status === "EXTEND_ORDER") {
            this.$router.replace({
              path: "/order/detail/" + data.result.orderId
            });
          } else {
            this.orderPrice = data.result;
          }
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    getCartInfo() {
      const cartIds = this.$route.params.id;
      if (!cartIds) {
        this.$dialog.error("參數有誤");
        return this.$router.go(-1);
      }
      postOrderConfirm(cartIds)
        .then(res => {
          console.log("xinxi");
          console.log(res);
          this.cartInfo = res.data.cartInfo;
          console.log("cartinfo");
          console.log(this.cartInfo);
          console.log(this.cartInfo[0].productInfo.id);
          // if (this.cartInfo[0].productInfo.id == 4985) {
          //   console.log("4985");
          //   this.userInfo.delivery_type = "顺丰速递";
          //   this.delivery_type = "顺丰速递";
          // }
          this.storePostage = res.data.priceGroup.storePostage;

          this.offlinePayStatus = res.data.offline_pay_status;
          this.orderGroupInfo = res.data;
          this.deduction = res.data.deduction;
          this.usableCoupon = res.data.usableCoupon || {};
          this.addressInfo = res.data.addressInfo || {};
          this.system_store = res.data.system_store || {};
          this.store_self_mention = res.data.store_self_mention;
          this.isTyrvaya = res.data.isTyrvaya;
          let that = this;
          this.getUserInfo();
          setTimeout(() => {
            that.computedPrice();
          }, 400);
        })
        .catch(() => {
          this.$dialog.error("加載訂單數據失敗");
        });
    },
    addressTap: function() {
      this.showAddress = true;
      if (!this.addressLoaded) {
        this.addressLoaded = true;
        this.$refs.mychild.getAddressList();
      }
    },
    addressRedirect() {
      this.addressLoaded = false;
      this.showAddress = false;
    },
    couponTap: function() {
      this.showCoupon = true;
    },
    changeCoupon: function(coupon) {
      if (!coupon) {
        this.usableCoupon = { coupon_title: "不使用優惠券", id: 0 };
      } else {
        this.usableCoupon = coupon;
      }
      this.computedPrice();
    },
    payItem: function(index) {
      this.active = index;
      this.computedPrice();
    },
    changeAddress(addressInfo) {
      this.addressInfo = addressInfo;
      this.computedPrice();
    },
    async createOrder() {
      this.isShowHint = false;
      this.isHinted = true;
      this.isShowHint2 = false;
      this.isHinted2 = true;
      let imageList = [];
      this.fileList.forEach(item => {
        imageList.push(item.url);
      });
      if (this.repurchaseIdcards.length > 0 && this.fileList.length == 0) {
        imageList = this.repurchaseIdcards;
      }
      console.log("imageList");
      console.log(imageList);
      // 研发机构不需要提交处方药
      if (imageList.length < 1 && this.repurchaseIdcards.length < 1) {
        this.$dialog.toast({
          mes: "請上傳身份證或戶口簿，總1張圖片！"
        });
        return;
      }
      let imageList2 = [];
      this.fileListCert.forEach(item => {
        imageList2.push(item.url);
      });
      if (this.repurchaseCerts.length > 0 && this.fileListCert.length == 0) {
        imageList2 = this.repurchaseCerts;
      }
      console.log("imageList2");
      console.log(imageList2);
      // 研发机构不需要提交处方药
      if (imageList2.length < 1 && this.repurchaseCerts.length < 1 && this.cartInfo[0].productInfo.is_prescription) {
        this.$dialog.toast({
          mes: "請上傳处方，總1張圖片！"
        });
        return;
      }
      if (!this.cartInfo[0].productInfo.is_prescription){
          imageList2 = [];
      }
      let shipping_type = this.shipping_type;
      if (!this.active) return this.$dialog.toast({ mes: "請選擇支付方式" });
      if (!this.addressInfo.id && !this.shipping_type)
        return this.$dialog.toast({ mes: "請選擇收貨地址" });
      console.log(this.userIdentity)
      console.log(this.userIdentity.name && this.userIdentity.idcard);
      if (!this.userIdentity.name || !this.userIdentity.idcard) {
        return this.$dialog.toast({ mes: "请上传身份证" });
      }
      console.log(1)
      if (
        this.userIdentity.name &&
        this.addressInfo.real_name != this.userIdentity.name
      ) {
        return this.$dialog.toast({ mes: "收货人姓名与身份证上不一致" });
      }
      console.log(2)
      if (this.shipping_type) {
        if (
          (this.contacts === "" || this.contactsTel === "") &&
          this.shipping_type
        )
          return this.$dialog.toast({ mes: "請填寫聯繫人或聯繫人電話" });
        if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.contactsTel)) {
          return this.$dialog.toast({ mes: "請填寫正確的手機號" });
        }
        if (!/^[\u4e00-\u9fa5\w]{2,16}$/.test(this.contacts)) {
          return this.$dialog.toast({ mes: "請填寫您的真實姓名" });
        }
      }
      console.log(3)
      if (!this.isWxPhone && !this.userInfo.wx_phone) {
        return this.$dialog.toast({ mes: "请填写绑定微信的手机号码" });
      }
      if (!this.isWxPhone && !this.userInfo.verify_code) {
        return this.$dialog.toast({ mes: "请填写验证码" });
      }
      console.log(5)
      
      if (!this.isWxPhone) {
      console.log(this.isWxPhone)
        let isError = false;
        await doVerifyCode({
          phone: this.userInfo.wx_phone,
          code: this.userInfo.verify_code
        }).catch(err => {
          console.log("cuowu");
          console.log(err);
          isError = true;
          return this.$dialog.toast({ mes: err.msg });
        });
        if (isError) return;
      }
      /*
      if (!this.isShowWarning) {
        return (this.isShowWarning = false);
      }*/
      console.log(this.userIdentity)
      this.$dialog.loading.open("生成訂單中");
      await createOrder(this.orderGroupInfo.orderKey, {
        real_name: this.contacts,
        phone: this.contactsTel,
        addressId: this.addressInfo.id,
        useIntegral: this.useIntegral ? 1 : 0,
        couponId: this.usableCoupon.id || 0,
        payType: this.active,
        pinkId: this.pinkId,
        seckill_id: this.orderGroupInfo.seckill_id,
        combinationId: this.orderGroupInfo.combination_id,
        bargainId: this.orderGroupInfo.bargain_id,
        from: this.from,
        mark: this.mark || "",
        shipping_type: parseInt(shipping_type) + 1,
        store_id: this.storeItem ? this.storeItem.id : 0,
        idcard_images: imageList,
        imageList: imageList2,
        productPriceList: this.realTimePrice ? this.productPriceList : [],
        realTimePrice: this.realTimePrice,
        certification_type: this.userInfo.certification_type,
        id_card: this.userIdentity.idcard,
        id_card_type: this.userIdentity.idcard_type,
        id_card_start_date: this.userIdentity.idcard_start_date,
        id_card_end_date: this.userIdentity.idcard_end_date,
        delivery_type: this.userInfo.delivery_type,
        wx_phone: this.userInfo.wx_phone
      })
        .then(res => {
          this.$dialog.loading.close();
          this.isShowWarning = false;
          const data = res.data;
          console.log("订单确认");
          console.log(data);
          console.log(this.userInfo);
          console.log(this.orderGroupInfo);
          let cartList = [];

          this.orderGroupInfo.cartInfo.forEach(item => {
            cartList.push(item.product_id + "");
          });
          orderDetail(data.result.orderId).then(res => {
            console.log(res.data);
            this.orderInfo = res.data; //订单详情
          });
          // return 1
          console.log(cartList);
          console.log(this.orderInfo, this.Afterpurchase, "打印详情》》》》》");
          console.log(this.Afterpurchase.data.status)
          
          if (
            (cartList.indexOf("5254") !== -1 ||
              cartList.indexOf("5255") !== -1 ||
              cartList.indexOf("5256") !== -1 ||
              cartList.indexOf("5257") !== -1) &&
            this.Afterpurchase.data.status === "SUCCESS"
          ) {
            console.log(
              this.orderInfo,
              this.Afterpurchase,
              "打印详情》》》》》"
            );
            console.log("跳转问卷");
            
            // window.open(
            //   `https://h5-test.unoeclinic.com/v2/#/article/wzQuestionnaire?order_id=${
            //     data.result.orderId
            //   }&type=routine&user_id=${this.userInfo.uid}`
            // );
            window.location.href = `https://h5.unoeclinic.com/v2/#/article/wzQuestionnaire?order_id=${
              data.result.orderId
            }&type=wechat&user_id=${this.userInfo.uid}`;
            return;
          } else {
            console.log("跳转支付");
            let url = "/order/status/" + data.result.orderId;
            switch (data.status) {
              case "ORDER_EXIST":
              case "EXTEND_ORDER":
              case "PAY_DEFICIENCY":
              case "PAY_ERROR":
                this.$dialog.toast({ mes: res.msg });
                this.$router.replace({
                  path: url + "/0?msg=" + res.msg
                });
                break;
              case "SUCCESS":
                this.$dialog.success("已提交審核");
                this.$router.replace({
                  path: "/order/detail/" + data.result.orderId
                });
                // this.$router.replace({
                //   path: url + "/1"
                // });
                break;
              case "ALIPAY_PAY":
                if (this.isWeixin) {
                  console.log("微信");
                  this.$router.push({
                    path: `/order/openAlipay?order_id=${
                      data.result.jsConfig.results.orderNo
                    }`
                  });
                } else {
                  console.log("非微信");
                  window.location.href = data.result.jsConfig.results.payScheme;
                }
                break;
              case "UNIONPAY_PAY":
                console.log("银联支付");
                console.log(data.result.jsConfig);
                this.$router.push({
                  name: `UnionPay`,
                  params: { jsconfig: data.result.jsConfig }
                });
                break;
              case "WECHAT_H5_PAY":
                setTimeout(() => {
                  window.location.href = data.result.jsConfig.results.payScheme;
                }, 100);
                break;
              case "WECHAT_PAY":
                setTimeout(() => {
                  window.location.href = data.result.jsConfig.results.payScheme;
                }, 100);
            }
          }
        })
        .catch(err => {
          this.$dialog.error(err.msg || "創建訂單失敗");
          this.$dialog.loading.close();
          //this.$router.go(-1);
        });
    },
    handleRemove(file, fileList) {
      console.log("shanchu");
      console.log(file);
      console.log(fileList);
      if (
        (file.name && file.idcard) ||
        this.userIdentity.name ||
        this.userIdentity.idcard
      ) {
        this.userIdentity = {};
      }
      this.fileList = fileList;
    },
    handleRemoveCert(file, fileList) {
      console.log("shanchu");
      console.log(file);
      console.log(fileList);
      this.fileListCert = fileList;
    },
    beforeAvatarUpload(file) {
      return new Promise((resolve, reject) => {
        let isLt2M = file.size / 1024 / 1024 < 5; // 判定图片大小是否小于5MB
        if (isLt2M) {
          imageConversion.compressAccurately(file, 400).then(
            res => {
              resolve(res);
            },
            err => {
              reject(err);
            }
          );
        }
        // 压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, 400).then(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    handleAvatarSuccess(res, file, fileList) {
      console.log("?");
      console.log(res);
      if (res.data.name && res.data.idcard) {
        this.userIdentity.name = res.data.name;
        this.userIdentity.idcard = res.data.idcard;
        this.userIdentity.idcard_type = res.data.type;
      }
      if (res.data.name && res.data.end_date) {
        this.userIdentity.idcard_type = res.data.type;
        this.userIdentity.idcard_end_date = res.data.end_date;
        this.userIdentity.idcard_start_date = res.data.start_date;
      }
      console.log(this.userIdentity);
      console.log("file");
      console.log(file);
      console.log("fileList");
      console.log(fileList);
      this.fileList.push({
        name: file.response.data.name,
        url: file.response.data.url
      });
    },
    handleAvatarSuccessCert(res, file, fileList) {
      console.log("?cert");
      console.log(res);
      console.log(this.userIdentity);
      console.log(fileList);
      this.fileListCert.push({
        name: file.response.data.name,
        url: file.response.data.url
      });
    },
    changePrice(val) {
      this.productPriceList = val;
      this.computedPrice();
    }
  }
};
</script>

<style scoped>
.order-submission .wrapper .shipping select {
  color: #999;
  padding-right: 0.15rem;
}
.order-submission .wrapper .shipping .iconfont {
  font-size: 0.3rem;
  color: #515151;
}
.order-submission .allAddress {
  width: 100%;
  background-image: linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  background-image: -webkit-linear-gradient(
    to bottom,
    #e93323 0%,
    #f5f5f5 100%
  );
  background-image: -moz-linear-gradient(to bottom, #e93323 0%, #f5f5f5 100%);
  padding-top: 1rem;
}
.unionpay-logo {
  width: 0.7rem;
  height: 0.7rem;
}
.order-submission .show-example {
  color: rgb(78, 2, 122);
  text-decoration: underline;
}
.unionpay-logo img {
  width: 100%;
  height: 100%;
}
.order-submission .allAddress .nav {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .allAddress .nav .item {
  width: 3.55rem;
}
.order-submission .allAddress .nav .item.on {
  position: relative;
  width: 2.5rem;
}
.order-submission .allAddress .nav .item.on:before {
  position: absolute;
  bottom: 0;
  content: "快递配送";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 3.55rem;
  border-width: 0 0.2rem 0.8rem 0;
  border-style: none solid solid;
  border-color: transparent transparent #fff;
  z-index: 9;
  border-radius: 0.07rem 0.3rem 0 0;
  text-align: center;
  line-height: 0.8rem;
}
/* .order-submission .allAddress .nav .item:nth-of-type(2).on:before {
  content: "到店自提";
  border-width: 0 0 0.8rem 0.2rem;
  border-radius: 0.3rem 0.07rem 0 0;
} */
.order-submission .allAddress .nav .item.on2 {
  position: relative;
}
/* .order-submission .allAddress .nav .item.on2:before {
  position: absolute;
  bottom: 0;
  content: "到店自提";
  font-size: 0.28rem;
  display: block;
  height: 0;
  width: 4.6rem;
  border-width: 0 0 0.6rem 0.6rem;
  border-style: none solid solid;
  border-color: transparent transparent #f7c1bd;
  border-radius: 0.4rem 0.06rem 0 0;
  text-align: center;
  line-height: 0.6rem;
} */
.order-submission .allAddress .nav .item:nth-of-type(1).on2:before {
  content: "快递配送";
  border-width: 0 0.6rem 0.6rem 0;
  border-radius: 0.06rem 0.4rem 0 0;
}
.order-submission .wx-phone {
  border: solid 1px #aaa;
  padding: 0.1rem 0.3rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.order-submission .verify-btn {
  background-color: rgb(0, 122, 204);
  color: #fff;
  padding: 0.2rem;
  border-radius: 0.1rem;
}
.order-submission .verify {
  border: solid 1px #aaa;
  padding: 0.1rem 0.3rem;
  display: flex;
  align-items: center;
  width: 30%;
  box-sizing: border-box;
  margin-right: 0.2rem;
}
.order-submission .verify-title {
  flex-grow: 1;
}
.order-submission .allAddress .address {
  width: 7.1rem;
  height: 1.5rem;
  margin: 0 auto;
}
.order-submission .allAddress .line {
  width: 7.1rem;
  margin: 0 auto;
}
.order-submission .wrapper .item .discount input::placeholder {
  color: #ccc;
}
.warm-tip {
  background: #fff;
  padding: 8px;
}
.warm-tip > div {
  color: red;
  font-size: 16px;
  line-height: 32px;
  text-align: center;
  border: 1px dashed #999;
  line-height: 30px;
  padding: 10px 5px;
}
.warm-tip .title {
  font-weight: 700;
}
.warm-tip .content {
  font-size: 14px;
  line-height: 24px;
  text-align: left;
  color: red;
  text-indent: 10px;
  margin-top: 0.1rem;
}
/* 下载协议 */
.promise {
  border-bottom: 1px solid #f0f0f0;
  padding: 0.27rem 0.3rem;
  font-size: 0.3rem;
}
.prove p {
  text-indent: 1em;
}
.image-box {
  text-align: center;
}
.image-box .el-image {
  border: 1px solid #999;
  margin-top: 0.25rem;
}
.image-box .big-view {
  color: #999;
}
/* 上传处方 */
.item /deep/ .el-icon-close {
  font-size: 22px;
}
.item /deep/ .upload-demo {
  text-align: center;
  margin-top: 2vh;
  border: 1px dashed #999;
  padding: 3%;
}
.item /deep/ .upload-demo .el-upload__tip {
  margin-top: 2vh;
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.make-payment {
  border: 1px solid #eee;
  margin-top: 5px;
}
.make-payment .title {
  text-align: center;
  font-weight: 550;
  padding: 0.25rem 0;
  background: #eee;
  color: #444;
}
.make-payment .item-box {
  border-top: 1px solid #eee;
  padding: 10px 5px;
}
.make-payment .item-box > div:last-child {
  font-size: 14px;
  color: #777;
  margin-top: 0.1rem;
}
.risk-warning {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  z-index: 6;
  text-align: center;
}
.risk-warning .risk-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #000000;
  opacity: 0.6;
}
.risk-warning .risk-body {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 60%;
  padding: 0.3rem 0;
  background-color: #fff;
  border-radius: 0.2rem;
}
.risk-warning .risk-title {
  font-size: 0.4rem;
}
.risk-warning .risk-content {
  margin: 0.3rem 0;
  padding: 0 0.2rem;
}
.risk-warning .risk-footer {
  display: flex;
  align-items: center;
  border-top: solid 1px #aaa;
  padding-top: 0.2rem;
}
.risk-warning .risk-footer div {
  width: 50%;
}
.risk-warning .risk-footer .risk-continue {
  color: rgb(0, 122, 204);
}
.risk-warning .risk-cancel {
  color: #aaa;
  border-right: solid 1px #aaa;
}
</style>
